export const USER_ROLE = {
  PSL_ADMIN: 'PSLAdmin',
  PSL_AGENT: 'PSLAgent',
  PSL_QA: 'PSLQA',
  PSL_CONTACT_CENTRE: 'PSLContactCentre',
  ANONYMOUS: 'ANONYMOUS'
};
